import AddProductAction from './AddProductAction'

export default AddProductAction
